function resolvableRecord(resolvables) {
  let resolvedValues = {};
  return {
    name: "resolvable-record",
    subscribe: (onUpdate) => {
      const unsubscribes = Object.values(resolvables).map((s) => s.subscribe(onUpdate));
      return () => {
        unsubscribes.forEach((u) => u());
      };
    },
    readStable: () => {
      const { isDirty, resolved } = Object.entries(resolvables).reduce(
        ({ isDirty: isDirty2, resolved: resolved2 }, [propName, subscription]) => {
          const lastPropValue = resolvedValues[propName];
          const propValue = subscription.readStable();
          return {
            isDirty: isDirty2 || propValue !== lastPropValue,
            resolved: {
              ...resolved2,
              [propName]: propValue
            }
          };
        },
        { isDirty: false, resolved: {} }
      );
      if (isDirty) {
        resolvedValues = resolved;
      }
      return resolvedValues;
    },
    triggerResolve: async () => {
      return await Promise.all(
        Object.entries(resolvables).map(
          ([propName, sub]) => sub.triggerResolve(resolvedValues[propName])
        )
      );
    }
  };
}
export {
  resolvableRecord
};
//# sourceMappingURL=resolvable-record.js.map